import React from 'react'
import DocumentTitle from 'react-document-title'
import ReactSVG from 'react-svg'
import {Link} from 'react-router-dom'

import {withStyles, Grid, Avatar, Button, Typography} from 'material-ui'

import {Hero, HeroContent} from './Hero'
import PlayButton from './PlayButton'
import VideoDialog from './VideoDialog'
import MainNav from './MainNav'

import hands from './svg/98724_hands.svg'
import logo from './svg/carefolio_logo_WHITE.svg'



const styles = theme => ({
    headerBackground: {
        zIndex: 0,
        position: 'relative',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-evenly',
        margin: "0 auto",
        background: 'url(/img/family-care.jpg) center center no-repeat',
        backgroundSize: 'cover',
        minHeight: "38em",
        '&::before': {
            content: `''`,
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundImage: 'linear-gradient(to bottom, #5884ff, #7eff7f)',
            opacity: 0.6,
        }
    },
    headerForeground: {
        zIndex: 1,
        position: "absolute",
        minHeight: "38em",
        top: 0,
        bottom: 0,
        left: 0,
        right:0,
    },
    content: {
        padding: 20,
        maxWidth: theme.layout.contentWidth,
        margin: "0 auto",
        marginBottom: 60,
        '& h1': theme.typography.display1,
        '& p': theme.typography.body1,
        '& li': theme.typography.body1,
    },
    grow: {
        flex: 1
    },
    headerTitle: {
        color: "white",
        fontSize: "3em",
        zIndex: 1,
    },
    headerSubtitle: {
        fontSize: "1.15em",
        zIndex: 1,
    },
    headerButton: {
        margin: "2em",
        opacity: 0.6,
        background: "white"
    },
    headerContent: {
        padding: theme.spacing.unit,
            [theme.breakpoints.up('sm')]: {
                marginTop: "7em",
            },
    },
})


class MainHeader extends React.Component {
    constructor (props) {
        super(props)
        this.state = {videoOpen: false}
    }

    openPlayer = () => {
        this.setState({videoOpen: true})
    }

    closePlayer = () => {
        this.setState({videoOpen: false})
    }

    render () {
        const {classes} = this.props
        const {videoOpen} = this.state
        return (
            <div>
                <div className={classes.headerBackground}/>
                <div className={classes.content, classes.headerForeground}>
                    <MainNav/>

                    <VideoDialog open={videoOpen} onClose={this.closePlayer}/>

                    <Grid container className={classes.headerContent} direction="column" justify="flex-end" alignItems="center">
                        <Grid item sm={1}>
                            <PlayButton onClick={this.openPlayer}/>
                        </Grid>
                        <Grid item sm>
                            <Typography component="p" align="center" className={classes.headerTitle}>Caring for a loved one can be tough.</Typography>
                        </Grid>
                        <Grid item sm>
                            <Typography align="center" className={classes.headerSubtitle}><strong>See how our easy to use app can help families and caregivers</strong></Typography>
                            <Typography align="center" className={classes.headerSubtitle}><strong>stay on top of your loved ones health information.</strong></Typography>
                        </Grid>
                        <Grid item sm={12}>
                            <Button
                                variant="contained"
                                className={classes.button, classes.headerButton}
                                component={Link}
                                to="/signup"
                                style={{borderRadius: 25}}>
                                <Typography align="center" style={{paddingTop: 3}}>Try Carefolio for Free</Typography>
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </div>
        )
    }
}


export default withStyles(styles)(MainHeader)


// WEBPACK FOOTER //
// ./src/components/MainHeader.jsx